module.exports = __webpack_public_path__ + "img/ADMINISTRATIVE.94c3a6a1.svg";